import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_payment_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  comp_settlement_method_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_payment_method_guid: fromDatatype.GuidDataFieldInterface;
  payment_amount: fromDatatype.NumericDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  scheduled_payment_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_payment_date: fromDatatype.TimestampTzDatatypeInterface;
  payment_voucher_hdr_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_payment_line_RowClass implements bl_aat_claim_cycle_payment_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  comp_settlement_method_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_payment_method_guid: fromDatatype.GuidDataFieldInterface;
  payment_amount: fromDatatype.NumericDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  scheduled_payment_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_payment_date: fromDatatype.TimestampTzDatatypeInterface;
  payment_voucher_hdr_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
